import React from 'react'
import LunchadorDemoPic from "../assets/images/Lunchador_Demo_2.PNG"
import CheckersDemoPic from "../assets/images/Checkers_Demo_2.PNG"
import CKTLDemoPic from "../assets/images/CKTL_demo_2.PNG"

function Projects(props) {

    const ref = React.useRef(null)

    React.useEffect(() => {
        props.attach(ref.current)
        }, [])

    return (
        <div ref={ref} id="projects" className="grid grid-cols-11 grid-rows-4 bg-cover bg-gradient-to-r from-gray-900 to-gray-800 text-white font-sans -mb-24">
            <div className="row-span-1 col-start-2 col-end-11 pt-20">
                <span className="text-center text-5xl less-than-md:text-lg less-than-xl:text-4xl tracking-widest font-semibold"><p>SOME THINGS I'M PROUD OF</p></span>
            </div>
            <a href="https://share.getcloudapp.com/WnuNwdb9" target="_blank" className="row-start-2 row-span-1 col-start-3 col-end-6">
                <div className="group relative rounded-md border-2 bg-green-500 mb-6 overflow-hidden">
                    <img src={LunchadorDemoPic} className="object-cover h-full w-full rounded-md text-center group-hover:opacity-20 duration-300" />
                    <figcaption className="absolute whitespace-nowrap w-full top-8 less-than-md:top-2 gpx-6 invisible group-hover:animate-slide group-hover:visible">
                        <h1 className="text-xl less-than-lg:text-md font-semibold">Lunchador</h1>
                        <hr className="w-full m-auto"></hr>
                        <p className="text-sm less-than-lg:text-xs whitespace-normal">Android app, uses AI to automate tracking food trucks based on Tweeted locations</p>
                        <h2 className="text-lg less-than-lg:text-sm font-semibold">Tags:</h2>
                        <p className="text-sm less-than-lg:text-xs whitespace-normal">Android, Mobile Development, React Native, Ruby on Rails, PostgreSQL</p>
                    </figcaption>
                </div>
            </a>
            <a href="https://share.getcloudapp.com/JruWXvJP" target="_blank" className="row-start-2 row-span-1 col-start-7 col-end-10">
                <div className="group relative rounded-md border-2 bg-green-500 mb-6 overflow-hidden">
                    <img src={CheckersDemoPic} className="object-cover rounded-md h-full w-full text-center group-hover:opacity-20 duration-300" />
                    <figcaption className="absolute whitespace-nowrap top-8 less-than-md:top-2 px-6 invisible group-hover:animate-slide group-hover:visible">
                        <h1 className="text-xl less-than-lg:text-md font-semibold">Checkers</h1>
                        <hr className="w-full m-auto"></hr>
                        <p className="text-sm less-than-lg:text-xs whitespace-normal">Multiplayer game of checkers, with save/load game feature</p>
                        <h2 className="text-lg less-than-lg:text-sm font-semibold">Tags:</h2>
                        <p className="text-sm less-than-lg:text-xs whitespace-normal">Javascript, HTML, CSS, Ruby on Rails, API</p>
                    </figcaption>
                </div>
            </a>
            <a href="https://share.getcloudapp.com/YEuA8v79" target="_blank" className="row-start-3 row-span-1 col-start-3 col-end-6">
                <div className="group relative border-2 rounded-md bg-green-500 overflow-hidden">
                    <img src={CKTLDemoPic} className="object-cover h-full w-full text-center rounded-md group-hover:opacity-20 duration-300" />
                    <figcaption className="absolute whitespace-nowrap top-8 px-6 invisible group-hover:animate-slide group-hover:visible">
                        <h1 className="text-xl less-than-lg:text-md font-semibold">CKTL</h1>
                        <hr className="w-full m-auto"></hr>
                        <p className="text-sm less-than-lg:text-xs whitespace-normal">An app for cocktail recipes based on what ingredients you have</p>
                        <h2 className="text-lg less-than-lg:text-sm font-semibold">Tags:</h2>
                        <p className="text-sm less-than-lg:text-xs whitespace-normal">Ruby</p>
                    </figcaption>
                </div>
            </a>
            <div className="row-start-3 row-span-1 col-start-7 col-end-10">
                   
            </div>
        </div>
    )
}

export default Projects